import { getTags } from './getTags';
import { toastError, toastSuccess } from '../../utils/toastMessage';
import API from '../../utils/API';

export const confirmDeletingTag = (id, name) => {
  return {
    type: 'CONFIRM_DELETING_TAG',
    id,
    name,
  };
};

export const cancelDeletingTag = () => {
  return {
    type: 'CANCEL_DELETING_TAG',
  };
};

export const tagDeleteSuccess = () => {
  return {
    type: 'TAG_DELETE_SUCCESS',
  };
};

export const tagDeleteError = () => {
  return {
    type: 'TAG_DELETE_ERROR',
  };
};

export const tagDelete = (id) => {
  return (dispatch) => {
    API.delete(`/tags/${id}`)
      .then(() => {
        toastSuccess();
        dispatch(tagDeleteSuccess());
        dispatch(getTags());
      })
      .catch(() => {
        dispatch(tagDeleteError());
        toastError();
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/tags/tagDelete.js